import React from 'react';
import { StatusBadge } from '../../../components/ui';
import type { BinStatus } from '../types';
import { BIN_STATUS_HINT, BIN_STATUS_LABEL, BIN_STATUS_VARIANT } from '../utils/binStatus';

/** One bin's standing against its band, through the shared badge (design-system.md: no local colour maps). */
const BinStatusBadge: React.FC<{ status: BinStatus }> = ({ status }) => (
  <span title={BIN_STATUS_HINT[status]}>
    <StatusBadge status={status} variant={BIN_STATUS_VARIANT[status]} label={BIN_STATUS_LABEL[status]} soft pill />
  </span>
);

export default BinStatusBadge;
